module.exports = __webpack_public_path__ + "img/shipo-menu-children-tick-filled.74fb327a.svg";